// reducer.js
import {
  SET_VALUE_Impression,
  SET_DATE_Impression,
  SET_CURRENT_PAGE_Impression,
  SET_ORDER_Impression,
  SET_SORT_FIELD_Impression,
  SET_VALID_Impression,
  SET_CATEGORIE_Impression,
} from "./actionsTypes";

const initialState = {
  value: "",
  date: "",
  valid: "",
  currentPage: 1,
  order: "desc",
  sortField: "creee_le",
  categorie: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VALUE_Impression:
      return {
        ...state,
        value: action.payload,
      };
    case SET_CATEGORIE_Impression:
      return {
        ...state,
        categorie: action.payload,
      };
    case SET_DATE_Impression:
      return {
        ...state,
        date: action.payload,
      };

    case SET_CURRENT_PAGE_Impression:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ORDER_Impression:
      return {
        ...state,
        order: action.payload,
      };
    case SET_SORT_FIELD_Impression:
      return {
        ...state,
        sortField: action.payload,
      };
    case SET_VALID_Impression:
      return {
        ...state,
        valid: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
